import { DateTime } from 'luxon';

export const TIME_ZONE = 'America/New_York';

export const formatDate = (isoDate: string, format: string) =>
    DateTime.fromISO(isoDate).setZone(TIME_ZONE).toFormat(format);
